// src/reports/ComparativaTotales.js
import React from "react";
import "./ComparativaTotales.css";

const ComparativaTotales = ({ data }) => {
  if (!data || !data.movimientos || !data.categorias || !data.presupuestos) {
    return <p>No hay datos suficientes para generar el informe.</p>;
  }

  const { movimientos, categorias, presupuestos } = data;

  // --- Crear mapa de categorías padre ---
  const subArrPadres = {};
  categorias
    .filter((cat) => !cat.idPadre)
    .forEach((cat) => {
      const pres = presupuestos.find((p) => p.categoriaId === cat.id);
      subArrPadres[cat.id] = {
        categoria: cat.nombre,
        total: 0,
        limite: pres ? pres.limite : 0,
      };
    });

  // --- Agrupar movimientos por mes y categoría padre ---
  const gastos = {};
  movimientos.forEach((mov) => {
    if (!mov.fecha || !mov.categoriaId || !mov.total) return;

    const mes = mov.fecha.slice(0, 7); // YYYY-MM
    const cat = categorias.find((c) => c.id === mov.categoriaId);
    if (!cat) return;

    // Determinar padre
    let padreId = cat.idPadre && cat.idPadre !== 0 ? cat.idPadre : cat.id;
    const catPadre = categorias.find((c) => c.id === padreId);
    const abueloId = catPadre?.idPadre && catPadre.idPadre !== 0 ? catPadre.idPadre : null;
    padreId = abueloId || padreId;

    // Inicializar mes
    if (!gastos[mes]) {
      gastos[mes] = {};
      Object.keys(subArrPadres).forEach((pid) => {
        gastos[mes][pid] = { ...subArrPadres[pid], total: 0 };
      });
    }

    // Sumar gasto absoluto
    gastos[mes][padreId].total += Math.abs(mov.total);
  });

  const meses = Object.keys(gastos).sort();
  const categoriasUnicas = Object.entries(subArrPadres);

  return (
    <div className="comparativa-container">
      <table className="comparativa-table">
        <thead>
        <tr>
            <th className="sticky">Categoría</th>
            <th className="sticky2">Presupuesto</th>
            {meses.map((mes) => (
                <th key={mes}>{mes}</th>
            ))}
        </tr>
        </thead>
        <tbody>
            {categoriasUnicas.map(([catId, cat]) => (
                <tr key={catId}>
                <td className="sticky">
                    {cat.categoria}
                </td>

                {/* Presupuesto UNA sola vez */}
                <td className="sticky2">
                    {subArrPadres[catId].limite.toFixed(2)}
                </td>

                {/* Meses desplazables */}
                {meses.map((mes) => {
                    const gasto = gastos[mes][catId]?.total ?? 0;
                    const limite = subArrPadres[catId].limite;

                    let color = "black";
                    if (gasto === 0 || gasto < limite / 2) color = "green";
                    else if (gasto < limite) color = "orange";
                    else color = "red";

                    return (
                    <td key={mes} style={{ color }}>
                        {gasto.toFixed(2)}
                    </td>
                    );
                })}
                </tr>
            ))}
            </tbody>
      </table>
    </div>
  );
};

export default ComparativaTotales;
